// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"31b23a98","146":"f4588a29","255":"66182ab4","388":"4e2858a7","488":"15c117bb","937":"66c5a938","957":"5707fe18","978":"0bd6c3e1"}[chunkId] + ".chunk.js";
};